export const CONFIRM_COLOR = {
  INFO: 'info',
  DANGER: 'danger',
}

export const ALERT_TYPE = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
}

export const NOTIFICATION_LEVEL = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
}

export const MESSAGES = {
  SERVER_ERROR: 'Internal Error. Please try again later or contact the administrator',
  SUCCESSFUL_DELETE: 'It has been successfully deleted',
  ERROR_FETCH: 'Error when fetching items',
  NO_PERMISSION: 'You cannot perform this action right now. Please try again later or contact the administrator.'
};

export const GRANT_ACTION = {
  GRANT: 'grant',
  REVOKE: 'revoke',
}

export const SUPPORTER_TITLE = {
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MISS: 'Miss',
  DR: 'Dr',
  MX: 'Mx'
}

export const CONTACT_LABEL = {
  EMAIL: ['Email', 'Alt_Email'],
  PHONE: ['Home', 'Mobile', 'Work', 'Alt_Home', 'Alt_Mobile', 'Alt_Work'],
}

export const ADDRESS_LABEL = {
  ADDRESS: ['Home', 'Work']
}

export const EMAIL_LABEL = {
  EMAIL: 'Email',
  ALT_EMAIL: 'Alt_Email',
}

export const CONTACT_TYPE = {
  EMAIL: 'email',
  PHONE: 'phone',
  ONLINE_PRESENCE: 'online-presence',
}

export const REGEX = {
  PHONE: '^[(+]?[0-9]+[)]?[0-9._ ()-]*$',
  EMAIL: '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$'
}